<h2 class="form__title">Document Properties

  <div class="alert alert-warning" *ngIf="showError">Please check all fields for errors that will prevent you from
    saving
  </div>

</h2>


<ng-form #documentForm="ngForm" novalidate class="form__cont" (change)="formChanged($event)"
  (touch)="formTouched($event)">
  <h3 class="full__section">Document Information</h3>

  <div class="form-container">
    <mat-form-field appearance="outline" required
      matTooltip="Fixed Term Contract: Has an End Date. Indefinite Contract: Continues for an indefinite duration">
      <mat-label>Document Class</mat-label>
      <mat-select [disabled]="!addMode && !((userRoles$ | async)?.superUser || (initiator$ | async))" name="ClassDescription"
        [(ngModel)]="doc.propertiesObj.ClassDescription">
        <ng-container *ngFor="let docClass of null | asyncChoiceListChoices:objectStore:'ACLDocumentClasses' | async">
          <mat-option *ngIf="showOption(docClass.id)" [value]="docClass.id">
            {{docClass.value}}
          </mat-option>
        </ng-container>
      </mat-select>

    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Contract Identifier</mat-label>
      <input matInput [value]="doc.propertiesObj?.ContractIdentifier ? doc.propertiesObj?.ContractIdentifier : ''"
        disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline" required
      matTooltip="Type of contract being uploaded eg Services Agreement/Sale Agreement/Confidentiality Agreement">
      <mat-label>Type of Agreement</mat-label>
      <mat-select #ContractAgreementType="ngModel" name="ContractAgreementType"
        [(ngModel)]="doc.propertiesObj.ContractAgreementType" required>
        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option *ngFor="let docClass of null | asyncChoiceListChoices:objectStore:'ContractAgreementTypes' | async"
          [value]="docClass.id">
          {{docClass.value}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="ContractAgreementType?.errors?.required">
        Field is required
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline" required matTooltip="Is the contract valid or terminated?">
      <mat-label>Contract Status</mat-label>
      <mat-select #ContractStatus="ngModel" name="ContractStatus" [(ngModel)]="doc.propertiesObj.ContractStatus"
        required>
        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option *ngFor="let docClass of null | asyncChoiceListChoices:objectStore:'ContractStatuses' | async"
          [value]="docClass.id">
          {{docClass.value}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="ContractStatus?.errors?.required">
        Field is required
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container full__section">
    <mat-form-field appearance="outline">
      <mat-label>Contract Name</mat-label>
      <input #Name="ngModel" name="Name" matInput maxlength="255" [(ngModel)]="doc.propertiesObj.DocumentTitle" required
        matTooltip="The name of the contract according to the Aspen contract naming convention.Non-Aspen Party_Name of Contract_Date of Last signature
        E.g. Comair Limited_Distribution Agreement_17/10/2010
        A reference number at the end of the name of your contract can be used only if this is practiced at your local Aspen
        office.
        E.g. Comair Limited_Distribution Agreement_17/10/2010_COM001" />
      <mat-error *ngIf="ContractStatus?.errors?.required">
        Field is required
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>CMSID</mat-label>
      <input matInput [value]="doc.propertiesObj?.ContractCMSID ? doc.propertiesObj?.ContractCMSID : ''" disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Document Type</mat-label>
      <input matInput [value]="doc.propertiesObj.ContractType | asyncChoiceList:objectStore:'ContractTypes' | async"
        disabled />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Location of Wet Ink</mat-label>
      <input #ContractWetInk="ngModel" maxlength="64" name="ContractWetInk" matInput
        [(ngModel)]="doc.propertiesObj.ContractWetInk" matTooltip="Where is the original Hard Copy/ Wet Ink stored" />
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>Contract Parties</mat-label>
      <input #ContractParties="ngModel" maxlength="256" name="ContractParties" matInput
        [(ngModel)]="doc.propertiesObj.ContractParties" matTooltip="All parties to the contract" />
    </mat-form-field>
  </div>

  <h3 class="full__section">Document Dates and Deadlines</h3>
  <!-- {{doc.propertiesObj.ContractStartDate}} -->
  <div class="form-container">
    <mat-form-field appearance="outline"
      matTooltip="The commencement date or effective date as set out in the contract.">
      <mat-label>Contract Start Date</mat-label>
      <input #ContractStartDate="ngModel" name="ContractStartDate" [(ngModel)]="doc.propertiesObj.ContractStartDate"
        matInput [matDatepicker]="pickerContractStartDate" placeholder="Choose a date yyyy/mm/dd"
        [required]="doc.propertiesObj.ClassDescription !== DocumentClasses.Transaction_Contract" />
      <mat-datepicker-toggle matSuffix [for]="pickerContractStartDate">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerContractStartDate></mat-datepicker>
      <mat-error *ngIf="ContractStartDate?.errors?.required">
        Field is required in format yyyy/mm/dd
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container" *ngIf="!doc.propertiesObj.ContractNoAlertRequired">
    <mat-form-field appearance="outline" matTooltip="The date that will trigger an alert reminder for contract">
      <mat-label>Review Deadline Date</mat-label>
      <input #ContractReviewDeadlineDate="ngModel" name="ContractReviewDeadlineDate"
        [(ngModel)]="doc.propertiesObj.ContractReviewDeadlineDate" matInput
        [required]="doc.propertiesObj.ClassDescription !== DocumentClasses.Transaction_Contract"
        [matDatepicker]="pickerContractReviewDeadlineDate" placeholder="Choose a date yyyy/mm/dd" [min]="tomorrow" />
      <mat-datepicker-toggle matSuffix [for]="pickerContractReviewDeadlineDate">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerContractReviewDeadlineDate></mat-datepicker>
      <mat-error *ngIf="ContractReviewDeadlineDate?.errors?.required">
        Field is required in format yyyy/mm/dd
      </mat-error>
      <mat-error *ngIf="ContractReviewDeadlineDate?.errors?.matDatepickerMin">
        Date should be after today
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container"
    *ngIf='doc?.propertiesObj?.ClassDescription === DocumentClasses.Fixed_Term_Contract || doc?.propertiesObj?.ClassDescription === DocumentClasses.Transaction_Contract'>
    <mat-form-field appearance="outline" matTooltip="Termination / Expiry Date as set out in the contract.">
      <mat-label>Contract End Date</mat-label>
      <input #ContractEndDate="ngModel" name="ContractEndDate" [(ngModel)]="doc.propertiesObj.ContractEndDate" matInput
        [matDatepicker]="pickerContractEndDate" placeholder="Choose a date yyyy/mm/dd"
        [required]="doc.propertiesObj.ClassDescription !== DocumentClasses.Transaction_Contract"
        [min]="doc.propertiesObj.ContractStartDate" />
      <mat-datepicker-toggle matSuffix [for]="pickerContractEndDate">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerContractEndDate></mat-datepicker>
      <mat-error *ngIf="ContractEndDate?.errors?.required">
        Field is required in format yyyy/mm/dd
      </mat-error>
      <mat-error *ngIf="ContractEndDate?.errors?.matDatepickerMin">
        Date should be after the Contract Start Date
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline" matTooltip="The date on which the contract was signed">
      <mat-label>Signature Date</mat-label>
      <input #ContractDateOfLastSignature="ngModel" name="ContractDateOfLastSignature"
        [(ngModel)]="doc.propertiesObj.ContractDateOfLastSignature" matInput
        [matDatepicker]="pickerContractDateOfLastSignature" placeholder=" Choose a date yyyy/mm/dd"
        [required]="doc.propertiesObj.ClassDescription !== DocumentClasses.Transaction_Contract"
        [max]="doc.propertiesObj.ContractEndDate" />
      <mat-datepicker-toggle matSuffix [for]="pickerContractDateOfLastSignature">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerContractDateOfLastSignature></mat-datepicker>
      <mat-error *ngIf="ContractDateOfLastSignature?.errors?.required">
        Field is required in format yyyy/mm/dd
      </mat-error>
      <mat-error *ngIf="ContractDateOfLastSignature?.errors?.matDatepickerMax">
        Date should be before the Contract End Date
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container">
    <section class="custom-check-box-group">
      <mat-checkbox class="custom-check-box" name="ContractNoAlertRequired"
        [(ngModel)]="doc.propertiesObj.ContractNoAlertRequired"
        (click)="doc.propertiesObj.ContractReviewDeadlineDate = undefined">No Alert Required</mat-checkbox>
    </section>
  </div>



  <h3 class="full__section">Additional Information</h3>

  <div class="form-container">

    <mat-form-field appearance="outline" required *ngIf="null | asyncBusinessOwnerAll | async as ownerAll"
      matTooltip="The name of the business representative that is responsible for the document">
      <mat-label>Business Owner</mat-label>
      <mat-select #ContractBusinessOwner="ngModel" name="ContractBusinessOwner"
        [(ngModel)]="doc.propertiesObj.ContractBusinessOwner" required (selectionChange)="boSelected($event)">
        <ngx-mat-select-search name="boSearch" [(ngModel)]="boSearch" [placeholderLabel]="'Search...'"
          [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option *ngFor="let ownr of ownerAll | stringFilterBy : boSearch : 'fullname'" [value]="ownr.id">
          {{ownr.fullname}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="ContractBusinessOwner?.errors?.required">
        Field is required
      </mat-error>
    </mat-form-field>
  </div>

  <ng-container *ngIf="doc.propertiesObj.ContractBusinessOwner | asyncBusinessOwnerEntity | async as owner">

    <div class="form-container">
      <mat-form-field appearance="outline"
        matTooltip="The email address of the business representative that is responsible for the document">
        <mat-label>Business Owner Email</mat-label>
        <input matInput [value]="owner.email" disabled />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline"
        matTooltip="The contact number of the business representative that is responsible for the document">
        <mat-label>Business Owner Contact Number</mat-label>
        <input matInput [value]="owner.telephone" disabled />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline"
        matTooltip="The department that business representative that is responsible for the document belongs to">
        <mat-label>Business Owner Department</mat-label>
        <input matInput [value]="owner.department" disabled />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline"
        matTooltip="The designation of the business representative that is responsible for the document">
        <mat-label>Business Owner Designation</mat-label>
        <input matInput [value]="owner.designation" disabled />
      </mat-form-field>
    </div>
  </ng-container>

  <div class="form-container full__section">
    <mat-form-field appearance="outline">
      <mat-label>Department</mat-label>
      <input #ContractDepartment="ngModel" maxlength="64" name="ContractDepartment" matInput
        [(ngModel)]="doc.propertiesObj.ContractDepartment" required
        matTooltip="The department the contract is prepared for" />
      <mat-error *ngIf="ContractDepartment?.errors?.required">
        Field is required
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container">
    <mat-form-field appearance="outline" required *ngIf="null | asyncLegalCounselAll | async as legalCounselAll"
      matTooltip="The name of the legal counsel that is responsible for the document">
      <mat-label>Legal Counsel</mat-label>
      <mat-select #ContractLegalCounsel="ngModel" name="ContractLegalCounsel"
        [(ngModel)]="doc.propertiesObj.ContractLegalCounsel" required (selectionChange)="lcSelected($event)">
        <ngx-mat-select-search name="lcSearch" [(ngModel)]="lcSearch" [placeholderLabel]="'Search...'"
          [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>
        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option *ngFor="let legalCounsel of legalCounselAll | stringFilterBy : lcSearch : 'fullname'" [value]="legalCounsel.id">
          {{legalCounsel.fullname}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="ContractLegalCounsel?.errors?.required">
        Field is required
      </mat-error>
    </mat-form-field>
  </div>

  <ng-container *ngIf="doc.propertiesObj.ContractLegalCounsel | asyncLegalCounselEntity | async as legalCounsel">
    <div class="form-container">
      <mat-form-field appearance="outline"
        matTooltip="The email address of the legal counsel that is responsible for the document">
        <mat-label>Legal Counsel Email</mat-label>
        <input matInput [value]="legalCounsel.email" disabled />
      </mat-form-field>
    </div>
  </ng-container>

  <h3 class="full__section">Product Data</h3>

  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label>UPI</mat-label>
      <input #ContractUPI="ngModel" maxlength="64" name="ContractUPI" matInput
        [(ngModel)]="doc.propertiesObj.ContractUPI" matTooltip="Unique Product Identifier" />
    </mat-form-field>
  </div>


  <div class="form-container">
    <app-multiselect-wrapper label="Products" name="ContractProducts" #ContractProducts="ngModel"
      [(ngModel)]="doc.propertiesObj.ContractProducts" choiceListName="allProducts" gerritServiceName="allProducts"
      [objectStore]="objectStore" [allowSearchFilter]="true" [allowCheckAll]="true"
      matTooltip="The drug or substance used to cure, treat, prevent disease or injury, a medicine">
    </app-multiselect-wrapper>
  </div>

  <div class="form-container">
    <app-multiselect-wrapper label="Molecules" name="ContractMolecules" #ContractMolecules="ngModel"
      [(ngModel)]="doc.propertiesObj.ContractMolecules" choiceListName="allMolecules" gerritServiceName="allMolecules"
      [objectStore]="objectStore" [allowSearchFilter]="true" [allowCheckAll]="true" [required]="masterDataRequired"
      matTooltip="The main component making up the drug(s)">
    </app-multiselect-wrapper>
  </div>

  <div class="form-container">
    <app-multiselect-wrapper label="Territories" name="ContractTerritories" #ContractTerritories="ngModel"
      [(ngModel)]="doc.propertiesObj.ContractTerritories" choiceListName="allTerritories"
      gerritServiceName="allTerritories" [objectStore]="objectStore" [allowSearchFilter]="true" [allowCheckAll]="true"
      [required]="masterDataRequired" matTooltip="The territory or country where the product is distributed">
    </app-multiselect-wrapper>

  </div>
  <!-- <div>
    {{doc | json}}
  </div> -->
</ng-form>
